import * as types from '../constants/screenConstants';

export const setIsMobileViewActions = (isMobileView) => async (dispatch) => {
  dispatch({
    type: types.SET_IS_MOBILE_VIEW,
    payload: isMobileView,
  });
};

export const setIsTabletViewActions = (isTabletView) => async (dispatch) => {
  dispatch({
    type: types.SET_IS_TABLET_VIEW,
    payload: isTabletView,
  });
};
